{
  "zoomControl": {
    "zoomIn": "Vergrößern",
    "zoomOut": "Verkleinern",
    "resetZoom": "Zoom zurück"
  },
  "roleTesting": {
    "title": "Rollentest",
    "testingAsLabel": "Testen als",
    "exitButton": "Rollentest beenden",
    "close": "Schließ",
    "tooltipFormat": "Als {{role}} testen - Klicken zum Ändern"
  },
  "languageSwitcher": {
    "title": "Sprache",
    "selectLabel": "Sprache",
    "close": "Schließ",
    "tooltip": "{{language}} – Klicken zum Ändern",
    "exitButton": "Beenden"
  },
  "support": {
    "contactSupport": "Kontakt Support",
    "dialogTitle": "Supportanfrage",
    "tutorialVideos": "Anleitungsvideos",
    "questionLabel": "Frage",
    "questionPlaceholder": "Deine Support-Anfrage hier eingeben...",
    "cancelButton": "Abbrechen",
    "sendButton": "Senden",
    "successMessage": "Danke! Deine Supportanfrage ist eingegangen. Wir melden uns in Kürze bei dir."
  },
  "selectTailNumber": {
    "tailNumberLabel": "Kennz.",
    "notInRegistryShort": "Noch nicht im Register.",
    "notInRegistryLong": "Dieses Flugzeug ist noch nicht in unserem Register.",
    "requestButton": "Anfrage",
    "requestDialogTitle": "Flugzeuganfrage senden",
    "requestDialogDescription": "Überprüfe die Details unten und klicke auf 'Anfrage senden', um dieses Flugzeug in unser Register aufzunehmen.",
    "tailNumberFieldLabel": "Kennzeichen",
    "fboLabel": "FBO",
    "requestedByLabel": "Angefordert von",
    "cancelButton": "Abbrechen",
    "submitRequestButton": "Anfrage senden",
    "submitting": "Wird gesendet...",
    "requestErrorMessage": "Anfrage konnte nicht gesendet werden. Bitte versuche es erneut.",
    "waitForCredentials": "Bitte warte, während wir deine Anmeldedaten überprüfen",
    "confirmationTitle": "✈️ Flugzeuganfrage gesendet!",
    "confirmationMessage": "Wir haben deine Anfrage für das Flugzeug <strong>{{tailNumber}}</strong> erhalten. Unser Team wird sie prüfen und bald in die Registry aufnehmen. Du wirst benachrichtigt, sobald es verfügbar ist.",
    "gotItButton": "Verstanden!"
  },
  "splitButton": {
    "ariaLabel": "Aufteil-Button",
    "selectStrategyAriaLabel": "Merge-Option"
  },
  "speedDialNav": {
    "label": "Label",
    "simplifyDemo": "Demo vereinfachen",
    "demo": "Demo",
    "userManagement": "Benutzerverwaltung"
  },
  "windDisplay": {
    "loading": "Lädt...",
    "noData": "--"
  },
  "dateRangeControl": {
    "startDate": "Startdatum",
    "endDate": "Enddatum",
    "next7Days": "Nächste 7 Tage",
    "thisWeek": "Diese Woche",
    "next30Days": "Nächste 30 Tage",
    "next60Days": "Nächste 60 Tage"
  },
  "favorites": {
    "nameLabel": "Name",
    "saveButton": "Speichern",
    "overwriteConfirm": "Ein Favorit mit dem Namen {{name}} existiert bereits. Möchtest du ihn überschreiben?",
    "overwriteButton": "Ja, überschreiben"
  },
  "assignTripButton": {
    "assigned": "Zugewiesen",
    "assign": "Zuweisen",
    "assignTo": "Zuweisen zu {{locationName}}",
    "assignedTo": "Zugewiesen an {{locationName}}",
    "assignSelected": "{{count}} ausgewählte Flüge zuweisen",
    "assignCount": "Zuweisen ({{count}})",
    "thisHangar": "Dieser Hangar",
    "thisRamp": "Vorfeld",
    "successMessage": "{{tailNumber}} wurde {{locationName}} zugewiesen",
    "bulkSuccessMessage": "{{count}} Flüge wurden {{locationName}} zugewiesen",
    "errorMessage": "Flugzuweisung fehlgeschlagen"
  },
  "layoutToolbar": {
    "tooltips": {
      "measuringTool": "Messwerkzeug"
    },
    "buttons": {
      "clear": "Löschen",
      "dump": "Dump",
      "print": "Drucken",
      "copy": "Kopie",
      "share": "Teilen",
      "allTenants": "Alle Mandanten"
    },
    "confirmations": {
      "pleaseConfirm": "Bitte bestätigen",
      "clearMultiHangar": "Das entfernt alle Flugzeuge in den ausgewählten Hangars.",
      "clearNuclear": "☢️ RADIKALE OPTION: Dies hebt die Zuweisung ALLER Flugzeuge von diesem {{locationType}} ab sofort bis zum Ende ihrer Trips auf. Das lässt sich nicht einfach rückgängig machen. Bist du sicher?",
      "clearLocation": "Das entfernt alle Flugzeuge, die in diesem {{locationType}} aufgeführt sind.",
      "clearNuclearOk": "Ja, alle Flüge löschen (UNWIDERRUFLICH)",
      "clearLocationOk": "Ja, alle Flugzeuge entfernen",
      "dumpMultiHangar": "Das entfernt alle Flugzeuge aus den ausgewählten Hangars.",
      "dumpScheduled": "Das entfernt alle Flugzeuge aus diesem {{locationType}} für die gesamte Flugdauer.",
      "dumpLocation": "Das verschiebt alle Flugzeuge nach vorne.",
      "dumpHangarsOk": "Ja, Hangars verwerfen",
      "dumpScheduledOk": "Ja, aus {{locationType}} entfernen",
      "dumpLocationOk": "Ja, Hangar verwerfen",
      "resetMultiHangar": "Das setzt die ausgewählten Hangars auf das Layout für alle Mieter zurück.",
      "resetLocation": "Das setzt das Layout für alle Mandanten ({{locationType}}) zurück.",
      "resetOk": "Ja, Reset",
      "printHangarsTitle": "Hangars drucken",
      "printHangarsCaption": "Wähle die Hangars aus, die du drucken möchtest.",
      "copyHangarsTitle": "Hangars kopieren",
      "copyHangarsCaption": "Wähle die Hangars aus, die du kopieren möchtest."
    },
    "messages": {
      "copiedToClipboard": "In Zwischenablage kopiert",
      "urlCopiedToClipboard": "URL in Zwischenablage kopiert"
    },
    "errors": {
      "failedToCopyUrl": "URL kopieren fehlgeschlagen",
      "failedToCopyImage": "Bild konnte nicht in die Zwischenablage kopiert werden. Das Bild ist möglicherweise zu groß oder es gibt ein Problem mit Hintergrundbildern.",
      "copyFailedDetailed": "Kopieren fehlgeschlagen für {{locationType}} {{locationName}}. Canvas-Größe: {{canvasWidth}}x{{canvasHeight}}. Prüfe die Browser-Konsole für detaillierte Logs.",
      "copyFailedGeneric": "Kopieren von {{locationType}} in die Zwischenablage fehlgeschlagen. Das Bild ist möglicherweise zu groß für den Speicher deines Geräts oder es gab ein Problem beim Rendern des Flugzeugs. Versuche es erneut oder prüfe die Konsole für Details.",
      "multiHangarCopyFailedDetailed": "Multi-Hangar-Kopie fehlgeschlagen. Canvas-Größe: {{canvasWidth}}x{{canvasHeight}}. Ausgewählte Hangars: {{hangarCount}}. Prüfe die Browser-Konsole für detaillierte Logs.",
      "multiHangarCopyFailedGeneric": "Kopieren des Multi-Hangar-Layouts in die Zwischenablage fehlgeschlagen. Das Bild ist möglicherweise zu groß für den Speicher deines Geräts oder es gab ein Problem beim Rendern der Flugzeuge. {{hangarCount}} Hangars ausgewählt. Versuche, weniger Hangars auszuwählen, oder prüfe die Konsole für Details."
    },
    "dialogs": {
      "featureNotSupported": {
        "title": "Funktion nicht unterstützt",
        "message": "Diese Funktion wird in Firefox nicht unterstützt. Wenn du sie nutzen möchtest, verwende bitte einen anderen Browser.",
        "okButton": "OK"
      },
      "copyFailed": {
        "title": "Kopie fehlg.",
        "okButton": "OK"
      }
    }
  },
  "favoritesButton": {
    "buttons": {
      "favorites": "Favoriten"
    },
    "dialogs": {
      "saveFavoriteTitle": "Favoritenstapel speichern",
      "favoritesTitle": "Favoriten",
      "pleaseConfirm": "Bitte bestätigen"
    },
    "emptyState": {
      "imageAlt": "Keine Favoriten",
      "message": "Noch keine Favoriten gespeichert. Klicke auf das Speichern-Symbol, um deine Favoriten-Stacks zu speichern."
    },
    "multiHangarFavorites": {
      "buttons": {
        "use": "Nutz",
        "delete": "Löschen"
      },
      "confirmations": {
        "useText": "Alle Luftfahrzeuge aus den ausgewählten Hangars entfernen und durch Luftfahrzeuge für '{{stackName}}' ersetzen.",
        "useNote": "Hinweis: Flugzeuge in diesem gespeicherten Stapel werden bei Bedarf aus anderen Hangars verschoben.",
        "useOk": "Ja, Reset",
        "deleteText": "Du bist dabei, '{{stackName}}' aus allen ausgewählten Hangars zu löschen.",
        "deleteNote": "Das bedeutet…wenn ‚{{stackName}}' für Hangars A, B, C gespeichert ist…aber ich nur A und B ausgewählt habe…dann behält C weiterhin sein gespeichertes ‚{{stackName}}'",
        "deleteOk": "Ja, diesen Favoriten löschen"
      },
      "stackColumn": "Stapel",
      "searchPlaceholder": "Suche nach Stack",
      "noStack": "Kein Stack"
    },
    "singleFavorite": {
      "printSubtitle": "Favorit: {{name}}",
      "searchPlaceholder": "Suche nach Stack",
      "buttons": {
        "use": "Nutz",
        "delete": "Löschen",
        "print": "Drucken"
      },
      "confirmations": {
        "title": "Bitte bestätigen",
        "useText": "Entferne alle Flugzeuge von deinem aktuellen {{locationType}} und ersetze sie durch Flugzeuge aus '{{name}}'.",
        "useOk": "Ja, auf gespeicherten Stack zurücksetzen",
        "deleteText": "Du bist dabei, {{name}} zu löschen.",
        "deleteOk": "Ja, diesen Favoriten löschen"
      }
    }
  },
  "multiLocationSave": {
    "labels": {
      "name": "Name"
    },
    "buttons": {
      "cancel": "Abbrechen",
      "save": "Speichern"
    },
    "confirmations": {
      "overwriteMessage": "Ein Favorit mit dem Namen {{name}} existiert bereits. Möchtest du ihn überschreiben?",
      "overwriteOk": "Ja, überschreiben"
    }
  },
  "addMovableObstacle": {
    "buttonText": "Bewegl. Hindernis hinzufügen",
    "dialogTitle": "Hindernis hinzufügen",
    "cancelButton": "Abbrechen",
    "doneButton": "Fertig",
    "movableObstacleGrid": {
      "columns": {
        "name": "Name",
        "lengthFt": "Länge (ft)",
        "widthFt": "Breite (ft)",
        "heightFt": "Höhe (ft)"
      },
      "notAvailable": "k.A.",
      "addButton": "Neu",
      "searchPlaceholder": "Hindernistyp nach Name suchen",
      "messages": {
        "addSuccess": "{{obstacleName}} zu {{locationName}} hinzugefügt",
        "addError": "Fehler beim Hinzufügen von {{obstacleName}}: {{errorMessage}}"
      }
    }
  },
  "addFBO": {
    "buttonLabel": "FBO hinzu",
    "dialogTitle": "FBO hinzufügen",
    "instructions": "Erstelle ein neues FBO und lade den ersten Benutzer ein.",
    "successMessage": "Eine E-Mail wurde an <b style=\"color: #3c6ce9\">{{email}}</b> mit einer Einladung zu <b style=\"color: #3c6ce9\">{{name}}</b> gesendet. Du kannst auch den Link unten verwenden.",
    "nameLabel": "Name",
    "emailLabel": "E-Mail-Adresse",
    "okButton": "OK",
    "cancelButton": "Abbrechen",
    "addButton": "Neu"
  },
  "buttonMoveTo": {
    "assignTo": "Zuweisen an",
    "moveTo": "Verschieben",
    "unassigned": "Nicht zugew."
  },
  "buttonNotes": {
    "buttonText": "Notizen"
  },
  "editTenant": {
    "dialogTitle": "Flugzeug bearbeiten",
    "selectAircraftLabel": "Flugzeug auswählen",
    "duplicateTailWarning": "Doppelte Kennzeichen",
    "ownerManagerLabel": "Inhaber/Manager",
    "notesLabel": "Notizen",
    "notesPlaceholder": "Notizen zu diesem Flugzeug hinzufügen...",
    "lastUpdate": "Letzte Aktualisierung: {{time}} ({{date}}) von {{user}}",
    "typeLabel": "Typ",
    "tenantOption": "Mandant",
    "transientOption": "Durchreisend",
    "yellowCardLabel": "Gelbe Karte (YC)",
    "unassignedText": "Nicht zugew.",
    "naText": "k.A.",
    "notHangaredText": "Nicht im Hangar",
    "confirmTitle": "Bitte bestätigen",
    "transientConfirmText": "Wenn du diesen Stammkunden zu einem Durchreisenden machst, ist dieses Flugzeug nicht mehr in deinen Hangars stationiert. Es bleibt auf deiner Liste der durchreisenden Flugzeuge.",
    "transient": "Durchreisend",
    "base": "Basis",
    "cancelButton": "Abbrechen",
    "saveButton": "Speichern",
    "insufficientPermissionTitle": "Keine Berechtigung",
    "insufficientPermissionText": "Keine Berechtigung, einen Basismieter zu bearbeiten. Aktuell hast du die Rolle <u>{{roleName}}</u>. Du musst <u>FBO Admin</u> oder <u>Manager</u> sein, um einen Basismieter zu bearbeiten. Bitte kontaktiere deinen AirPlx-Admin, falls du denkst, dass dies ein Fehler ist."
  },
  "aircraftSpecsTooltip": {
    "heightLabel": "H: {{height}}"
  },
  "fboMenu": {
    "switchFBO": "FBO wechseln",
    "noFBOTitle": "Kein FBO gefunden",
    "noFBOMessage": "Du gehörst derzeit keinem FBO an. Bitte kontaktiere deinen Systemadministrator, um einem beizutreten.",
    "okButton": "OK"
  },
  "buttonUploadImage": {
    "compressingMessage": "Bild wird komprimiert. Das dauert einen Moment."
  },
  "selectDumpTo": {
    "label": "An:",
    "holdingArea": "Wartebereich",
    "frontOfHangar": "Vor dem Hangar"
  },
  "locationTextField": {
    "unassigned": "Nicht zugew.",
    "ramp": "Vorfeld",
    "hangar": "Hangar",
    "assignedLabel": "Zugewiesener {{locationType}}",
    "currentLabel": "Aktuelle {{locationType}}"
  },
  "aircraftListItem": {
    "tenant": "Mandant",
    "transient": "Durchreisend",
    "yc": "YC",
    "noseIn": "Nase rein",
    "tailIn": "Einparken",
    "front": "Vorne",
    "back": "Zurück",
    "okOutside": "OK Außen",
    "locked": "Gesperrt"
  },
  "timelineAircraftList": {
    "title": "Zeitleiste",
    "aircraftCount": "{{count}} Flugzeuge",
    "filterPlaceholder": "Filter...",
    "searchPlaceholder": "Suche Kennzeichen in allen Flügen...",
    "countOfTotal": "{{filtered}} von {{total}}",
    "totalAndHere": "{{total}} gesamt • {{here}} hier",
    "filteredAndHere": "{{filtered}} von {{total}} • {{filteredHere}} hier",
    "noAircraftFound": "Kein Flugzeug mit Kennzeichen {{tailNumber}} gefunden",
    "createNewTrip": "Neuen Flug erstellen"
  },
  "multiHangarSelect": {
    "selectAll": "Alle auswählen",
    "cancel": "Abbrechen",
    "ok": "OK"
  },
  "timelineAircraftListItem": {
    "cancelled": "STORNIERT",
    "here": "HIER",
    "hereNow": "JETZT HIER",
    "unassigned": "Nicht zugew.",
    "unassignedStatus": "NICHT ZUGEW.",
    "atLocation": "AT {{locationName}}",
    "arrivesInHours": "ANKUNFT IN {{hours}}H",
    "arrivesInDays": "ANKUNFT IN {{days}}T",
    "unknownAircraft": "Unbekanntes Luftfahrzeug"
  },
  "aircraftPreferencesMenu": {
    "tailIn": "Einparken",
    "noseIn": "Nase rein",
    "frontRow": "Erste Reihe",
    "backRow": "Hintere R.",
    "okOutside": "OK Außen",
    "locked": "Gesperrt",
    "incrementalPark": "Inkrementeller Park",
    "editAircraft": "Flugzeug bearbeiten",
    "removeAircraft": "Flugzeug entfernen",
    "removeObstacle": "Hindernis entfernen",
    "confirmRemove": "Ja, dieses Flugzeug entfernen",
    "confirmTitle": "Bitte bestätigen",
    "confirmTextReference": "Wenn du diesen Tenant zu einem Transient machst, ist dieses Flugzeug nicht mehr in deinen Hangars stationiert. Es bleibt auf deiner Transient-Liste.",
    "confirmTextRemove": "Dieses Flugzeug wird aus diesem {{locationType}} entfernt.",
    "hangar": "Hangar",
    "ramp": "Vorfeld"
  },
  "aircraftActionMenu": {
    "noActiveTripWarning": "Kein aktiver oder bevorstehender Trip für dieses Flugzeug gefunden",
    "tripDetailsNotFound": "Flugdetails nicht gefunden",
    "assignedForEntireTrip": "{{tailNumber}} für den gesamten Flug {{locationName}} zugewiesen",
    "failedAssignEntireTrip": "Flugzuweisung fehlgeschlagen",
    "assigned": "{{tailNumber}} zugewiesen an {{locationName}}",
    "failedAssignAircraft": "Flugzeugzuweisung fehlgeschlagen",
    "jumpTo": "Gehe zu...",
    "assignHere": "Hier zuweisen",
    "assignHereEntireTrip": "Hier zuweisen (gesamter Flug)",
    "failedLoadTrips": "Flüge für dieses Flugzeug konnten nicht geladen werden",
    "viewTrips": "Flüge anzeigen",
    "hereAt": "— Hier bei {{locationName}} —",
    "hoursStay": "{{hours}}h Aufenthalt",
    "otherLocations": "— Andere Standorte —",
    "andMoreAt": "...und {{count}} weitere bei {{locationName}}",
    "todayAt": "Heute um {{time}}",
    "tomorrowAt": "Morgen um {{time}}",
    "yesterdayAt": "Gestern um {{time}}",
    "inDaysAt": "In {{days}} Tagen um {{time}}"
  },
  "bulkActionToolbar": {
    "tripsSelected": "{{count}} Flug ausgewählt",
    "selectLocation": "Standort auswählen...",
    "assign": "Zuweisen",
    "unassign": "Entfernen",
    "cancel": "Abbrechen",
    "delete": "Löschen",
    "clear": "Löschen"
  },
  "scheduledAircraftContextMenu": {
    "confirmTitle": "Bitte bestätigen",
    "confirmRemoveText": "Das Flugzeug wird zu diesem Zeitpunkt aus dem Zeitplan entfernt.",
    "confirmRemoveButton": "Ja, aus Zeitplan entfernen",
    "missingDataError": "Erforderliche Daten für Standortwechsel fehlen",
    "conflictError": "Ein anderes Flugzeug befindet sich bereits zu dieser Zeit an diesem Standort",
    "gapError": "Lücken im Zeitplan können nicht erstellt werden",
    "updateLocationError": "Standort-Update fehlgeschlagen",
    "loadTripsError": "Flüge für dieses Flugzeug konnten nicht geladen werden",
    "viewTrips": "Flüge anzeigen",
    "unlock": "🔓 Entsperren",
    "lock": "🔒 Sperren",
    "tailIn": "Einparken",
    "noseIn": "Nase rein",
    "frontRow": "Erste Reihe",
    "backRow": "Hintere R.",
    "okOutside": "OK Außen",
    "locked": "Gesperrt",
    "moveTo": "Verschieben",
    "editAircraft": "Flugzeug bearbeiten",
    "removeAircraft": "Flugzeug entfernen",
    "unassigned": "Nicht zugew."
  },
  "addTenantButton": {
    "tooltipAddTrip": "Hinzufügen",
    "tooltipAddAircraft": "Flugzeug hinzuf.",
    "buttonAddTrip": "Hinzufügen",
    "buttonAddAircraft": "Flugzeug hinzuf.",
    "dialogTitleAddTrip": "Hinzufügen",
    "dialogTitleAddAircraft": "Flugzeug hinzuf.",
    "tabs": {
      "newAircraft": "Neues Flugzeug",
      "priorTransients": "Frühere Transits",
      "tenants": "Mandanten",
      "bulkAdd": "Sammel-Add",
      "addTrip": "Hinzufügen",
      "allTrips": "Alle Flüge",
      "bulkUpload": "Massenupload",
      "addMovableObstacle": "Hindernis hinzufügen"
    },
    "buttons": {
      "cancel": "Abbrechen",
      "add": "Neu",
      "createTrip": "Flug erstellen",
      "creating": "Erstelle...",
      "saveTrips": "Trips speichern",
      "saving": "Speichern...",
      "done": "Fertig"
    },
    "notifications": {
      "addedToLocation": "{{model}} zu {{locationName}} hinzugefügt",
      "added": "{{model}} hinzugefügt",
      "tryAutostack": "Führen Sie AutoStack aus, um Ihr neues Flugzeug in Aktion zu sehen!",
      "runAutostack": "AutoStack ausführen"
    },
    "confirmTitle": "Bitte bestätigen",
    "confirmHangar": "Wir weisen diesen neuen Base Tenant diesem Hangar zu. Wenn du die Standard-Hangarzuweisung ändern möchtest, kannst du das über die Bearbeitung dieses Flugzeugs tun.",
    "confirmRamp": "Wir weisen diesen neuen Dauerparkmieter dieser Abstellfläche zu. Wenn du die Standard-Abstellflächen ändern möchtest, kannst du das in den Einstellungen dieses Flugzeugs bearbeiten."
  },
  "viewSettings": {
    "buttonText": "Einstellungen",
    "locationNotAvailable": "Standort nicht verfügbar",
    "tugUpdatedSuccess": "Schlepper für {{locationName}} aktualisiert",
    "tugUpdateError": "Schlepper-Update fehlgeschlagen",
    "tailNumberTooltip": "Kennzeichen auf Flugzeug anzeigen",
    "tailNumberLabel": "Kennz.",
    "notesTooltip": "Um einzelne oder alle Notizen zu sehen, gehe zu Einstellungen > Konfiguration",
    "notesLabel": "Notizen",
    "modelTooltip": "Flugzeugmodell auf Luftfahrzeug anzeigen",
    "modelLabel": "Modell",
    "footprintTooltip": "Spannweite und Länge bei ausgewähltem Flugzeug anzeigen",
    "footprintLabel": "Maße",
    "sopSpacingTooltip": "Horizontaler Abstandsrahmen",
    "sopSpacingLabel": "SOP-Abstand",
    "wallSpacingTooltip": "Wandabstand visuelle Füllbereiche",
    "wallSpacingLabel": "Wandabstand-Füllung",
    "bayBoundariesTooltip": "Hallenabschnitte für Staffelgiebel-Hangars anzeigen",
    "bayBoundariesLabel": "Hallenabgrenzungen",
    "overlapsTooltip": "Hebt alle Überlappungen hervor, bewertet nicht die vertikale Abstandssicherheit",
    "overlapsLabel": "Konflikte",
    "coPilotTooltip": "Wähle nicht gestapelte Flugzeuge und erhalte SOP-konforme Optionen",
    "coPilotLabel": "Co-Pilot",
    "tugLabel": "Tug",
    "useFBODefault": "FBO-Standard verwenden ({{defaultTugName}})",
    "spotsTooltip": "Parkpositionen auf dem Vorfeld anzeigen",
    "spotsLabel": "Plätze",
    "rampImageTooltip": "Satellitenbild über Vorfeld einblenden",
    "rampImageLabel": "Vorfeldaufnahme",
    "zoneHeatmapTooltip": "Zonenbelegung als Heatmap anzeigen (nächste {{hours}} h)",
    "zoneHeatmapLabel": "Zonen-Heatmap",
    "hours24": "24 h",
    "hours72": "72 h",
    "week1": "1W",
    "none": "Keine"
  },
  "currentAircraft": {
    "title": "Aktuelles Flugzeug"
  },
  "layout": {
    "permissionDenied": {
      "modifyLayout": "Du hast keine Berechtigung, das Layout zu ändern"
    },
    "deleteConfirmation": {
      "confirmAircraft": "Flugzeug bestätigen",
      "confirmObstacle": "Hindernis bestätigen",
      "removeAircraft": "Flugzeug entfernen",
      "removeObstacle": "Hindernis entfernen",
      "removeTransient": "Entfernen",
      "title": "Löschen bestätigen"
    }
  }
}
